import ApiService from './api.service.js'
import { TokenService } from './storage.service'

const customerOwnedAwsService = {
  submitCustomerAccount: async (data) => {
    const apiUrl = process.env.VUE_APP_REG_CUST_OWNED_ACCTS
    if (!apiUrl) {
      console.error('Customer owned services API is not configured')
      throw new Error('Customer owned services API is not configured')
    }

    // const currentUser = TokenService.getCurrentUser() || {}
    // const payload = {
    //   ...data,
    //   requestorId: currentUser.requestor_id || null,
    //   requestorEmail: currentUser.email || null
    // }
    // if (data.requestManagedServices === false) {
    //   payload.status = 'Completed'
    // } else {
    //   payload.status = 'Pending'
    // }
    console.log('Submitting customer account with data:', data)
    try {
      let response = await ApiService.post(process.env.VUE_APP_REG_CUST_OWNED_ACCTS, data)
      console.log(response.data)
      return response.data
    } catch (error) {
      console.error('Error submitting customer account:', error)
      throw new Error('Error: ' + error)
    }
  },
  getCustomerOwnedAccounts: async function (data) {
    console.log('Getting customer owned accounts with data:', data)
    try {
      let custParams = {
        params: {
          action: 'list',
          size: 10,
          orderBy: 'customer_owned_id',
          order: 'desc'
        }
      }
      if (data && Object.prototype.hasOwnProperty.call(data, 'nextPageKey')) {
        custParams.params.nextPageKey = data.nextPageKey
      }
      if (data && data.search) {
        custParams.params.search = data.search
      }
      let custResponse = await ApiService.get(process.env.VUE_APP_REG_CUST_OWNED_ACCTS, custParams)
      console.log(custResponse)
      return custResponse.data
    } catch (error) {
      throw new Error('Error: ', error)
    }
  },
  approveRequest: async function (data) {
    try {
      const payload = {
        action: 'approve',
        requestId: data.requestId,
        status: data.status
      }
      console.log('Payload for approving request:', payload)
      let response = await ApiService.put(process.env.VUE_APP_REG_CUST_OWNED_ACCTS, payload)
      console.log('Request approved successfully:', response.data)
      return response.data
    } catch (error) {
      console.error('Error approving request:', error)
      throw new Error('Error: ' + error)
    }
  },
  downloadTemplate: async function () {
    const apiUrl = process.env.VUE_APP_REG_CUST_OWNED_ACCTS
    if (!apiUrl) {
      console.error('Customer owned services API is not configured')
      throw new Error('Customer owned services API is not configured')
    }
    try {
      const response = await ApiService.get(apiUrl, {
        params: { action: 'download' }
      })
      return response
    } catch (error) {
      console.error('Error downloading customer-owned template:', error)
      throw new Error('Error: ' + error)
    }
  },
  sendEmailNotification: async function (params, callback) {
    console.log('Sending email notification with params:', params)
    const apiUrl = process.env.VUE_APP_GALAXY_MAIL_SERVER_API
    if (!apiUrl) {
      console.error('Galaxy mail server API is not configured')
      throw new Error('Galaxy mail server API is not configured')
    }
    try {
      let res = await ApiService.post(apiUrl, params)
      return res.data
    } catch (error) {
      throw new Error('Error:' + error)
    }
  },
}
export default customerOwnedAwsService
